import { createI18n } from "vue-i18n";
// Import your locale files directly
import tr from "@/locales/tr.js";
//import tr from '@/locales/tr.json'

const SUPPORT_LOCALES = ["en", "fa", "tr"];

function detectUserLocale() {
  //const browserLang = navigator.language.split("-")[0];
  //return SUPPORT_LOCALES.includes(browserLang) ? browserLang : "tr";
  return "tr";
}

function getSavedLocale() {
  return localStorage.getItem("user_local") || detectUserLocale();
}

const i18n = createI18n({
  legacy: false,
  locale: getSavedLocale(),
  fallbackLocale: "tr",
  globalInjection: true,
  messages: {
    tr,
  },
});

export async function loadLocaleMessages(locale) {
  if (!SUPPORT_LOCALES.includes(locale)) return;

  if (!i18n.global.availableLocales.includes(locale)) {
    const messages = await import(`@/locales/${locale}.js`);
    i18n.global.setLocaleMessage(locale, messages.default);
  }

  i18n.global.locale.value = locale;
  localStorage.setItem("user_local", locale);
}

export default i18n;

/*
const messages = {
  en,
  tr,
  // Add other languages
}
export default createI18n({
  legacy: false,
  globalInjection: true,
  locale: "en",
  fallbackLocale: "en",
  availableLocales: ["en", "tr"],
  messages: messages,
  specialCharacters: {
    linked: "~@",
  },
});


watch(
  () => i18n.global.locale.value,
  (newLocale) => {
    document.dir = ['fa', 'ar'].includes(newLocale) ? 'rtl' : 'ltr'
  },
  { immediate: true }
)




*/
